import React from 'react'
import { Box, Divider } from 'pcln-design-system'
import {
  useContentful,
  getVariantContent,
  IToutType,
  IVariationCollectionType
} from '@pcln/contentful-components'
import GenericBanner from '@/components/GenericBanner'
import MerchModuleWrapper from '@/components/MerchModuleWrapper'
import useSeti from '@/hooks/useSeti'
import isContentIVariationCollectionType from '@/shared-utils/is-content-ivariation-collection-type'
import CreditCardContent from './content'

export default function CreditCard() {
  const barclaysPromoFromContentful = useContentful('creditCardPromo') as
    | IToutType
    | IVariationCollectionType
    | undefined

  const isVariantCollection = isContentIVariationCollectionType<IToutType>(
    barclaysPromoFromContentful
  )

  const setiName = useSeti(
    isVariantCollection ? barclaysPromoFromContentful.experimentName : ''
  )
  const promo = isVariantCollection
    ? (getVariantContent(setiName, barclaysPromoFromContentful) as
        | IToutType
        | undefined)
    : barclaysPromoFromContentful

  return promo != null ? (
    <Box>
      <MerchModuleWrapper
        {...(promo as IToutType)}
        backgroundColor="background.lightest"
        credCardModWrapDefaultDisplay
      />
      <Divider borderColor="border.base" my={0} />
    </Box>
  ) : (
    <GenericBanner
      content={CreditCardContent}
      backgroundColor="background.lightest"
    />
  )
}
